import { Show } from "solid-js";
import type { User } from "../state/user.tsx";
import { MemberAvatar } from "../components/avatar/Avatar.tsx";
import { DECORATIVE_IMAGE_ALT } from "../constants.ts";

type PageHeaderProps = {
  title: string;
  subTitle: string;
  logoSrc?: string;
  user?: User;
};

const PageHeader = (props: PageHeaderProps) => (
  <header class="flex h-24 w-full items-center gap-x-3 border-b border-subtle bg-surface-default px-8 py-6 mobile:border-b-0 mobile:bg-surface-extra-subtle mobile:px-6">
    <Show when={props.logoSrc}>
      {(src) => (
        <div class="flex size-10 shrink-0 items-center justify-center rounded-xs bg-accent-brand">
          <img src={src()} alt={DECORATIVE_IMAGE_ALT} />
        </div>
      )}
    </Show>
    <Show when={props.user}>{(user) => <MemberAvatar member={user()} size="lg" />}</Show>
    <hgroup>
      <h1 class="text-header-lg text-primary">{props.title}</h1>
      <p class="text-medium-regular text-secondary">{props.subTitle}</p>
    </hgroup>
  </header>
);

export default PageHeader;
